import {
  airDisruptionApi,
  DisruptionRebookPlanResponseEnum,
  type DisruptionFailure,
  type RebookPlanSuccess,
} from "@b2bportal/air-disruption-api";
import { makeAxiosRequest, type RichError } from "@b2bportal/core-utilities";
import { createApi, fakeBaseQuery } from "@reduxjs/toolkit/query/react";
import axios from "axios";

const api = airDisruptionApi(axios);

export const flightsRebookPlanApi = createApi({
  baseQuery: fakeBaseQuery<RichError<DisruptionFailure>>(),
  reducerPath: "flightsRebook/plan",
  tagTypes: ["RebookPlan"],
  endpoints: (builder) => ({
    fetchQuote: builder.query<RebookPlanSuccess, { contractId: string }>({
      queryFn: async ({ contractId }) => {
        const result = await makeAxiosRequest(
          api.apiV0DisruptionExerciseRebookPlanPost({ contractId }),
          {
            discriminator: "DisruptionRebookPlanResponse",
            success: DisruptionRebookPlanResponseEnum.RebookPlanSuccess,
            failure: DisruptionRebookPlanResponseEnum.RebookPlanFailure,
          },
          { failure: (error) => error.reason }
        );

        if (result.isOk()) {
          return { data: result.value };
        } else {
          return {
            error: result.error,
          };
        }
      },
      providesTags: (result) => (result ? [{ type: "RebookPlan" }] : []),
    }),
  }),
});

export type FlightsRebookPlanState = ReturnType<
  typeof flightsRebookPlanApi.reducer
>;
